<div class="modal-content">
<div class="modal-content modal-edit-self-report"  *ngIf="!params['component'] || params['component'] === 'SelfReports'">
        <div class="modal-header">
        <h4 class="modal-title help-btn">
            {{ params['title'] | translate }}
        </h4>
    </div>
    <div class="modal-body">
        <edit-modal-header-action-component [params]="params"  (openFormModalAction)="openFormModal.emit()"  (deleteAction)="delete.emit()" (hideModalAction)="hideModal.emit()"> </edit-modal-header-action-component>

        <ng-template [ngIf]="!formLoading">
            <form [formGroup]="form" novalidate class="mat-form" #formDirective="ngForm">
                <ng-container *ngFor="let language of languages; let first = first">
                    <mat-expansion-panel class="mt-2"
                                         [class.invalid]="(!form.controls['name_' + language['locale']].valid && formSubmitted)"
                                         [expanded] = "first || params['action'] === 'create'"
                                         (opened)="panelOpenState = true"
                                         (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{ language['name'] }}
                            </mat-panel-title>
                            <mat-panel-description>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div class="container">
                            <div class="row">
                                <div #nameFG class="form-group col-xs-5">
                                    <mat-form-field class="ps-content">
                                        <input type="text" matInput [placeholder]="('Self Report Name' | translate)"
                                               [formControlName]="'name_' + language['locale']"
                                               (focus)="onInputFocused($event, nameFG)"/>
                                        <small class="form-text text-danger" [hidden]="form.controls['name_' + language['locale']].valid
                                                                            || (form.controls['name_' + language['locale']].pristine
                                                                            && !formSubmitted)">
                                            {{ 'Require at least 3 characters.' | translate }}
                                        </small>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                    </mat-expansion-panel>
                </ng-container>

                <div *ngIf="this.authService.isSuperAdmin" class="mt-2 row">
                    <div #standard class="form-group col-xs-4">
                        <mat-form-field class="" *ngIf="this.authService.isSuperAdmin">
                            <mat-select [placeholder]="'Medical Standard' | translate" formControlName="type">
                                <ng-container *ngFor="let standard of standards">
                                    <mat-option [value]="standard['id']">
                                        {{ standard['name'] }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div #domainName class="form-group col-xs-4">
                        <mat-form-field class="ps-content" *ngIf="this.authService.isSuperAdmin">
                            <mat-select #matDomain
                                        [placeholder]="'Domains' | translate"
                                        class="matSelect-domains"
                                        formControlName="domains"
                                        multiple>
                                <input formControlName="searchTxt"
                                       class="matSelect-domains--filter"
                                       type="text"
                                       matInput
                                       [placeholder]="('Search' | translate)">
                                <ng-container *ngFor="let domain of domains | searchArray : form.controls['searchTxt'].value : 'name_' + itemLanguage ">
                                    <mat-option [class.hidden]="domain['hidden']" [selected]="form.controls['domains']?.value?.indexOf(domain['id']) > -1" [value]="domain['id']">
                                        {{ domain['name_' + itemLanguage] | translate }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mt-2">
                    <label class="col-xs-12 lbl-card">
                        {{ 'Selected Domains' | translate}}
                    </label>
                    <div class="col-xs-6 selected-domains">
                        <ng-container *ngFor="let item of domains">
                            <div class="row selected-domains--item" *ngIf="form.controls['domains']?.value?.indexOf(item['id']) > -1">
                                <div class="col-xs-10">
                                    <span>
                                        {{item['name_' + itemLanguage]}} <br/>
                                    </span>
                                </div>
                                <div class="col-xs-2">
                                    <a *ngIf="params['action'] !== 'read'" class="btn btn-link table--grid__action-btn" (click)="removeDomain(item)">
                                        <i class="far fa-trash-alt table--grid__actions__links__icon"
                                           attr.name="{{ 'Delete' | translate }}" aria-hidden="true"
                                           title="{{ 'Delete' | translate }}" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12 text-xs-right">
                        <button type="button" class="btn btn-secondary" (click)="hideModal.emit()">
                            {{ 'Cancel' | translate }}
                        </button>
                        <button *ngIf="params['action'] !== 'read'" type="button" class="btn btn-primary" (click)="submit.emit()">
                            {{ 'Submit' | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </ng-template>
    </div>
</div>